import { call, put } from 'redux-saga/effects';
import { olConnectionV2 } from '../requesters/olConnection';
import { getUserSubscriptionQuery } from '../queries/userSubscriptionQuery';
import { receiveProductAssets } from '../actions/productAssetsActions';

/**
 * Calls the requester to get product assets
 * @param {String} fieldUuid
 * @return {void}
 */
export function* getProductAssets(fieldUuid, proxyingLegacyUserId) {
  const variables = {
    fieldUuids: [fieldUuid],
    legacyUserId: proxyingLegacyUserId
  };
  const { data: { userSubscription } } = yield call(olConnectionV2, getUserSubscriptionQuery(variables));
  yield put(receiveProductAssets(userSubscription));
  return userSubscription.featuresByFields[0].features;
}
